<div class="stepper" [ngClass]="{'stepTextGapOff' : stepTextGapOff}">
    <ng-container *ngFor="let step of stepperObjectArray">
        <span class="stepper__step"
              [class.completed]="step.status === 'COMPLETED'"
              [class.current]="step.status === 'CURRENT'">
        </span>
        <span class="stepper__step-text">{{step.label}}</span>
    </ng-container>
</div>
